import { render, staticRenderFns } from "./HomeMercapromo.vue?vue&type=template&id=382252b8&scoped=true"
import script from "./HomeMercapromo.vue?vue&type=script&lang=js"
export * from "./HomeMercapromo.vue?vue&type=script&lang=js"
import style0 from "./HomeMercapromo.vue?vue&type=style&index=0&id=382252b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382252b8",
  null
  
)

export default component.exports